import React from "react";
import InputWrapper from "../components/InputWrapper";
import GitInfo from 'react-git-info/macro';
import { connect } from "react-redux";
import {
  assignPhoneNumber,
  getAffiliate,
  getCountries,
  getIframeInfo,
  getSubjectSuggestions,
  openServiceCall,
  sendSMSV2,
} from "../services/actions";
import Button from "@material-ui/core/Button";
import { Icon } from "@material-ui/core";
import Config from "../constants/Config";
import { parsePhoneNumber } from "libphonenumber-js/max";
import { withTranslation } from "react-i18next";
import { isRtl } from "../services/Helpers";
import Enums from "../services/Enums";
import i18n from "i18next";
import { SpetzModal } from "../components/SpetzModal";
import '../styles/container.scss';
import { datadogLogs } from '@datadog/browser-logs';

import { setCallDetailsCountryId, setCallDetailsServiceSubject, setCallDetailsActive, setCallDetailsLongLat } from "../store/CallDetails/callDetailsSlice";
import { setAdminVars } from "../store/AdminVars/adminVarsSlice";
import { ChatContainer } from "./chat-container";

const inputs = [
  {
    type: "autoComplete",
    innerText:"Requested Service",
    placeholder: "Select a service",
    source: getSubjectSuggestions,
    formID: "serviceSubjectName",
    showRequiredErr: false,
    isRequired: true,
  },
  {
    type: "searchBar",
    innerText:"Location Required",
    placeholder: "Enter your location",
    formID: "serviceAreaName",
    showRequiredErr: false,
    isRequired: true,
  },
  {
    type: "freeText",
    innerText:"Name",
    placeholder: "Enter your name",
    formID: "clientName",
    showRequiredErr: false,
    isRequired: true,
  },
  {
    type: "freeText",
    innerText:"Contact Number",
    placeholder: "Enter your number",
    formID: "phoneNumber",
    showRequiredErr: false,
    isRequired: true,
    inputType: "tel",
  },
];

const optionalInputs = [
  {
    type: "select",
    innerText:"When To Contact You?",
    //placeholder: "tomorrowScheduled",
    formID: "dateRequired",
  },
  {
    type: "freeText2",
    innerText:"Problem Description (Optional)",
    placeholder: "writeHere",
    formID: "description",
  },
];

class IframeContainer extends React.Component {
  
  constructor(props) {
    super(props);
    this.handleMessageEvent = this.handleMessageEvent.bind(this);

    this.state = {
      isMobile: this.isMobileDevice(),
      timeOutId: null,
      form: {
        serviceSubjectName: "",
        phoneNumber: "",
        clientName: "",
        description: "",
        serviceCallType: "",
        serviceAreaName: "",
        dateRequired: "",
        countryId: "",
        agreementText: "",
        privacyUrl: "",
        TermsUrl: "",
      },
      twilioPhoneNumber:undefined, // Replace with your call center's phone number
      isSubmitDisabled: false,
      openModal: false,
      openServiceCall: {},
      prevForm: {},
      isWrongNumber: false,
      hideCallNowButton: false,
      missingOpenByCallDetails: false,
      willUserBePromptedForLocation: false,
      showChat: false,
    };
  }

  isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|mobile|android|iphone|ipad|phone|Opera Mini/i.test(navigator.userAgent);
  }

  async setCountry() {
    let countryAlpha2FromUrl = this.props.match.params.country;
    countryAlpha2FromUrl = countryAlpha2FromUrl
      ? countryAlpha2FromUrl.toUpperCase()
      : "GB";
    const countries = await getCountries();
    let country = countries.find((c) => c.Alpha2 === countryAlpha2FromUrl);
    if (!country) {
      country = countries.find((c) => c.Alpha2 === "GB");
    }
    await Enums.enumsIntialized();
    const languages = Enums.getEnum("Languages");
    if (languages.length) {
      const lng = languages.find((l) => {
        return l.id === country.LanguageId;
      });
      this.props.setCallDetailsCountryId(country.Id);
      this.setState({ language: lng, countryId: country.Id });
      await i18n.changeLanguage(lng.name);
    }
    return country;
  }

  //This function is used to get the iframe info from the given country ID from the API.
  // It then searches for the agreement text,
  // privacy URL and terms URL and stores them in variables.
  // It then returns an array of all these values.
  async getIframeInfo() {
    let iframeInfo = await getIframeInfo(this.state.countryId);
    this.props.setAdminVars(iframeInfo);
    this.setState({ twilioPhoneNumber: iframeInfo?.find((x) => x.VarName === "OpenServiceCallPhoneNumber")?.VarValue });
    const agreementText = iframeInfo?.find(
      (x) => x.VarName === "AgreementText"
    )?.VarValue;
    const privacyUrl = iframeInfo?.find(
      (x) => x.VarName === "PrivacyUrl"
    )?.VarValue;
    const termsUrl = iframeInfo?.find(
      (x) => x.VarName === "TermsUrl"
    )?.VarValue;
    const secondsToWait = iframeInfo?.find(
      (x) => x.VarName === "PinCodeMinWaitTimeSendTime"
    )?.VarValue;
    return [agreementText, privacyUrl, termsUrl, secondsToWait];
  }

  async componentDidMount() {
    const {isMobile} = this.state;
    const {isActive} = this.props.callDetails

    if(isMobile && isActive){
      window.addEventListener("message", this.handleMessageEvent);
    }
    const params = new URLSearchParams(this.props.location.search);
    const country = await this.setCountry();
    const [agreementText, privacyUrl, termsUrl, secondsToWait] = await this.getIframeInfo();
    const successUrl = params.get("successUrl");
    const serviceSubject = params.get(
      `serviceSubject${country.Id === 1 ? "Name" : ""}`
    );
    const serviceAreaName = params.get("serviceAreaName");
    const affiliateId = Number.parseInt(params.get("affiliateId")) || "550";
    let affiliate = await getAffiliate(affiliateId);
    let showChat = false;
    if (affiliate && affiliate.ServiceCallFlow === 'ByChat') {
      showChat = true
    }
    let form = this.state.form;
    if (serviceSubject) {
      form.serviceSubjectName = { description: serviceSubject };
      this.props.setCallDetailsServiceSubject(serviceSubject);
      this.props.setCallDetailsActive(true);
    }
    if (serviceAreaName) {
      form.serviceAreaName = { description: serviceAreaName };
    }
    const googleParams = this.getGoogleCampaignData();
    datadogLogs.logger.info(`Iframe loaded with the following google related params. campaignId:${googleParams.campaignId} gclId: ${googleParams.gclId} searchTerm: ${googleParams.searchTerm}`, googleParams);

    let hideCallNowButton = false;
    /*if (navigator.permissions) {
      const result = await navigator.permissions.query({ name: 'geolocation' });
      if (result.state == 'denied') {
        hideCallNowButton = true;
      } else if (result.state == 'prompt') {
        this.setState({ willUserBePromptedForLocation: true });
      }
    }*/ //disabled for now, as we do not want to ask for location permission 

    this.setState({
      serviceSubject,
      successUrl,
      form,
      country,
      affiliateId,
      serviceAreaName,
      agreementText,
      privacyUrl,
      termsUrl,
      secondsToWait,
      hideCallNowButton,
      showChat
    });

  }

  // tracking data from google ads
  getGoogleCampaignData = () => {
    let googleCampaign = {
      campaignId: null,
      gclId: null,
      searchTerm: null,
    };
    try {
      const params = new URLSearchParams(this.props.location.search);
      const campaignId = params.get("campaignid");
      googleCampaign.campaignId =
        campaignId == null ? null : Number(campaignId);
      googleCampaign.gclId = params.get("gclid");
      googleCampaign.searchTerm = params.get("keyword");
    } catch (ex) {
      console.log(`error get URL params: ${ex}`);
    }

    return googleCampaign;
  };

  showBranchVersion = () => {
    const { t } = this.props;
    const gitInfo = GitInfo();
    if (gitInfo.tags.length > 0) {
      const env = process.env['REACT_APP_ENV'];
      return `${t("environment")}: ${t(env)},  ${t("buildVersion")}: ${gitInfo.tags[0]}`
    }
  }

  //when Spetz It clicked
  handleOpenServiceCall = async (form) => {
    const { clientName, dateRequired: { value }, description, phoneNumber, serviceAreaName, serviceSubjectName} = this.state.prevForm
    if (serviceAreaName.description === form.serviceAreaName.description && phoneNumber === form.phoneNumber
      && serviceSubjectName.description === form.serviceSubjectName.description && clientName === form.clientName
      && description === form.description && value === form.dateRequired.value) { 
      // No field values has been Changed
      this.setState({ openModal: true, isSubmitDisabled: true, isWrongNumber: false })
      await sendSMSV2(form.phoneNumber, this.state.country.Id);
    } else {
      //Field changed, open new service call
      this.setState({isWrongNumber: false})
      this.createServiceCall(this.state.form)
    }
  }

  //when wrongNumber button is clicked
  handleChangeNumber = () => { 
    //Close the Modal and enable to change the fields and update the clicked state
    this.setState({ openModal: false, isSubmitDisabled: false, isWrongNumber: true })
  }

  goThanksScreen = () => { 
    const { country } = this.state;
    const results = this.state.openServiceCall;

    const israelParams = `?ServiceSubjectText=${
      results.serviceSubjectName
    }&ServiceAreaText=${results.serviceAreaName}&
                              OpenerName=${
                                results.clientName
                              }&OpenerPhoneNumber=${
      "0" + results.phoneNumber.slice(3)
    }`;
    let serviceCallUrlParam =
      country.Alpha2 === "IL"
        ? `&ServiceCallId=${results.serviceCallId}`
        : `?ServiceCallId=${results.serviceCallId}`;

    if (results.grade != null){
      serviceCallUrlParam += `&Grade=${results.grade}`;
    }
    const defaultSuccessURL =
      country.Alpha2 === "IL"
        ? Config.defaultSuccessURL[country.Alpha2] + israelParams
        : Config.defaultSuccessURL[country.Alpha2] ||
          Config.defaultSuccessURL.default;

    this.postEnhancedConversionsParams(results.phoneNumber, results.clientName, results.address);
    // The navigation to "ThankYou" screen will be done by the modal
    window.top.location.href = this.state.successUrl
      ? this.state.successUrl
      : defaultSuccessURL + serviceCallUrlParam;
  }

  createServiceCall = async (form) => {
    this.setState({ isSubmitDisabled: true});
    const { country } = this.state;
    let invalidForm = 0;
    inputs.map((field) => {
      if (!form[field.formID] || form[field.formID] === "") {
        field.showRequiredErr = true;
        invalidForm = 1;
      } else {
        field.showRequiredErr = false;
      }
    });
    if (invalidForm) {
      this.setState({
        showPhoneErr: false,
        showRequiredFieldsErr: true,
        isSubmitDisabled: false,
      });
      return;
    }
    if (form.serviceAreaName.description === "London") {
      this.setState({
        showPhoneErr: false,
        showRequiredFieldsErr: false,
        showLondonErr: true,
        isSubmitDisabled: false,
      });
      return;
    }

    try {
      const phoneNumber = parsePhoneNumber(form.phoneNumber, country.Alpha2);
      if (phoneNumber.isValid() && phoneNumber.country === country.Alpha2) {
        form.phoneNumber = phoneNumber.number.slice(1);
      } else {
        this.setState({
          showPhoneErr: true,
          showRequiredFieldsErr: false,
          isSubmitDisabled: false,
          showLondonErr: false,
        });
        return;
      }
    } catch (e) {
      this.setState({
        showPhoneErr: true,
        showRequiredFieldsErr: false,
        isSubmitDisabled: false,
        showLondonErr: false,
      });
      return;
    }

    let results = await openServiceCall({
      serviceCall: form,
      affiliateId: this.state.affiliateId,
      countryId: country["Id"],
      campaign: this.getGoogleCampaignData(),
    });
    this.setState({ prevForm: {...form} })
    this.setState({ openServiceCall: results })

    if (results.IsVerifyBySMS) {
      await sendSMSV2(this.state.form.phoneNumber, country.Id);
      this.setState({ openModal: true })
      return;
    }
    if (results.err) {
      this.setState({
        showError: results.err.ErrorMessage,
        showPhoneErr: false,
        isSubmitDisabled: false,
        showLondonErr: false,
      });
    }
    this.goThanksScreen();
  };

  postEnhancedConversionsParams = (phoneNumber,clientName,clientAddress) => {
    const customerName = clientName.split(" ");
    const firstName = customerName[0];
    const lastName = customerName[1] !== undefined? customerName[1] : ""

    window.parent.postMessage(
        {
          phoneNumber: `+${phoneNumber}`,
          firstName: firstName,
          lastName: lastName,
          address: clientAddress,
        }, "*"
    )
  }

  handleMessageEvent(event) {
    console.log('event:')
    if (event.data && event.data.type === "Google_Forward_Number") {
      if(this.state.timeOutId) {
        clearTimeout(this.state.timeOutId);
        this.setState({timeOutId: null});
      }
      const phoneNumber = event.data.phoneNumber;
      console.log("Received Google_Forward_Number message with phone number:", phoneNumber);
      // Do something with the phone number here
      window.open(`tel:${phoneNumber}`, '_self');
      this.setState({twilioPhoneNumber: phoneNumber})
    }
  }

  updateForm = (type, value) => {
    let { form } = this.state;
    form[type] = value;
    if(type === "serviceSubjectName" && value.description){
      this.props.setCallDetailsServiceSubject(value.description);
    }

    if(type === "serviceAreaName" && value.lat && value.long) { 
      this.props.setCallDetailsLongLat({longitude: value.long, latitude: value.lat});
    }
    this.setState({ form });
  };
  
  successCallback = (position) => {
    const { longitude, latitude } = position.coords;
    this.props.setCallDetailsLongLat({longitude, latitude});
  };

  
onCallNowClick = async () => {
  const { gclId } = this.getGoogleCampaignData();
  datadogLogs.logger.info(`gclId=${gclId}: user clicked on the Call Now button`);

  try {
    //const position = await this.getCurrentPosition();
    if (this.state.willUserBePromptedForLocation) {
      this.setState({ willUserBePromptedForLocation: false });
      datadogLogs.logger.info(`gclId=${gclId}: user allowed location`);
    }
    //this.successCallback(position);
  } catch (error) {
    if (error.code == error.PERMISSION_DENIED) {
      this.setState({ hideCallNowButton: true });
      if (this.state.willUserBePromptedForLocation) {
        this.setState({ willUserBePromptedForLocation: false });
        datadogLogs.logger.info(`gclId=${gclId}: user disabled location`);
      }
    }
  } finally {
    if (!this.state.hideCallNowButton) {
      const { ServiceSubjectName, Longitude, Latitude, CountryId } = this.props.callDetails;
      if (!ServiceSubjectName) {
        this.setState({ missingOpenByCallDetails: true });
        return;
      } else if (this.state.missingOpenByCallDetails) {
        this.setState({ missingOpenByCallDetails: false });
      }

      const { campaignId, gclId, searchTerm } = this.getGoogleCampaignData();
      const assignPhoneNumberPayload = {
        CallAssignment: {
          ServiceSubjectName,
          // Longitude,
          // Latitude,
          CountryId,
        },
        SearchTerm: searchTerm,
        ClickId: gclId,
        CampaignId: campaignId,
      };

      try {
        //datadogLogs.logger.info(`gclId: ${gclId} - before assignPhoneNumber`);

        const res = await assignPhoneNumber(assignPhoneNumberPayload);
        if (res && res.data) {
          const { PhoneNumber, OrderId, Grade } = res.data;
          const message = {
            type: "CALL_NOW_CLICKED",
            phoneNumber: PhoneNumber,
            grade: Grade,
            orderId: OrderId,
          };
          //datadogLogs.logger.info(`gclId: ${gclId} - window.parent.postMessage`);

          window.parent.postMessage(message, "*");
          this.setState({ twilioPhoneNumber: `${PhoneNumber}` });
        }
      } catch (err) {
        datadogLogs.logger.error(`gclId: ${gclId} - Error!`,err, err);

        console.log("error:", err);
      }
    }
  }
};

  // Define a function that returns a Promise object
  getCurrentPosition() {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }

  callNow() {
    return (
      <div className={"text-header"} style={{ flexDirection: 'column' }}>
        <div style={{padding:'5px'}}>
          {/* <div style={{color:'black', margin:5, }}>Call Now</div> */}
          <div style={{ display: 'flex', alignItems: 'center',justifyContent:'center' }}>
            <div className={"button-text-container"}>
              <Button
                style={{width:'100%'}}
                variant="contained"
                className={"send-button"}
                onClick={this.onCallNowClick}
                size={"large"}
                endIcon={
                  <Icon style={isRtl() ? { marginRight: "10px" } : {}}>
                    {isRtl() ? "phone" : "phone"}
                  </Icon>
                }
              >
                Call Now
              </Button>
            </div>
          </div>
        </div>
        {
          this.state.missingOpenByCallDetails &&
          <div style={{ color: 'red', fontWeight: "normal", fontSize: 16 }}>
              Please fill out the requested service first
          </div>
        }
        <div style={{color:'black'}}>Or fill out your details:</div>
      </div>
    )
  }

  render() {
    const { isMobile } = this.state;
    const {isActive} = this.props.callDetails
    const OpenCallByPhoneEnabled = this.props.adminVars.data?.find(x => x.VarName === "OpenCallByPhoneEnabled")?.VarValue?.toLowerCase() === "true";
    let {
      showError,
      showRequiredFieldsErr,
      showPhoneErr,
      showLondonErr,
      country,
      language,
      affiliateId
    } = this.state;
    if (!country) return null;
    const { t } = this.props;

    // split agreement text to parts with and without {{}} to be able to add links
    const agreementTextParts = this.state.agreementText?.split(/{{(.*?)}}/) || [];

    // if showChat is true, then we need to render the chat container.
    if(this.state.showChat) {
      return <ChatContainer country={country.Id} affiliate={affiliateId}/>;
    }
    return (
      <div className={`iframe-container ${country.Id === 1 ? "Israel" : ""}`}>
    
        <div className={"text-header"}>
          {t("findSpecialist")}
        </div>
        
       
        {isMobile && OpenCallByPhoneEnabled && !this.state.hideCallNowButton && this.callNow()}

        {
          this.state.openModal
          &&
          <SpetzModal
            openModal={this.state.openModal}
            goThanksScreen={this.goThanksScreen}
            serviceCallId={this.state.openServiceCall.serviceCallId}
            phoneNumber={this.state.openServiceCall.phoneNumber}
            countryID={this.state.country.Id}
            handleChangeNumber={this.handleChangeNumber}
            secondsToWait={this.state.secondsToWait}
          />
        }
        {
          <div className={"inputs-container"}>
            <div className={"top-inputs-container"}>
              {inputs.map((input, key) => (
                <div>
                  <div className={'innerText'}>{input.innerText}</div>
                  <InputWrapper
                    key={key}
                    type={input.type}
                    icon={country.Id !== 1 && input.icon}
                    innerText={t(input.label)}
                    placeholder={t(input.placeholder)}
                    options={input.options}
                    source={(text) =>
                      getSubjectSuggestions(text, country.Id, language.id)
                    }
                    updateForm={this.updateForm}
                    formID={input.formID}
                    isRequired={input.isRequired}
                    showRequired={input.showRequiredErr}
                    showPhoneErr={this.state.showPhoneErr}
                    showLondonErr={this.state.showLondonErr}
                    serviceSubject={this.state.serviceSubject}
                    serviceAreaName={this.state.serviceAreaName}
                    inputType={input.inputType}
                    emptyForm={this.state.emptyForm}
                    country={country}
                  />
                </div>
              )
              )}
            </div>
            <div className={"bottom-inputs-container"}>
              {optionalInputs.map((input, key) => (
                <div>
                  <div className={'optional-inner-text'}>{input.innerText}</div>
                  <InputWrapper
                  key={key}
                  type={input.type}
                  icon={country.Id !== 1 && input.icon}
                  placeholder={t(input.placeholder)}
                  options={input.options}
                  source={input.source}
                  updateForm={this.updateForm}
                  formID={input.formID}
                  isRequired={input.isRequired}
                  showRequired={this.state.showRequiredFieldsErr}
                  showPhoneErr={this.state.showPhoneErr}
                  emptyForm={this.state.emptyForm}
                  country={country}
                />
                </div>
                
              ))}
            </div>
          </div>
        }
        {showError && (
          <div style={{ color: "red", fontSize: 14, fontWeight: "bold" }}>
            {showError}
          </div>
        )}
        {showRequiredFieldsErr && (
          <div style={{ color: "red", fontSize: 14, fontWeight: "bold" }}>
            {t("allFieldsRequiredError")}
          </div>
        )}
        {showPhoneErr && (
          <div style={{ color: "red", fontSize: 14, fontWeight: "bold" }}>
            {t("invalidPhoneError")}
          </div>
        )}
        {showLondonErr && (
          <div style={{ color: "red", fontSize: 14, fontWeight: "bold" }}>
            {t("invalidLocationError")}
          </div>
        )}
        <div className={"button-text-container"}>
          <Button
            variant="contained"
            className={"send-button"}
            onClick={() => {
              if (this.state.isWrongNumber) {
                this.handleOpenServiceCall(this.state.form)
              } else {
                this.createServiceCall(this.state.form)
              }
            }}
            disabled={this.state.isSubmitDisabled}
            size={"large"}
            endIcon={
              <Icon style={isRtl() ? { marginRight: "10px" } : {}}>
                {isRtl() ? "west" : "east"}
              </Icon>
            }
          >
            {t("SpetzIt")}
          </Button>

          <div style={{ marginTop: "10px" }}>
            {agreementTextParts.map((part, index) => {
              if (part === "Terms_Of_Service") {
                return (
                  <a
                    style={{ textDecoration: "underline", color: "#474747" }}
                    href={this.state.termsUrl}
                    target="_blank"
                  >
                    <span style={{ fontSize: 11 }}>Terms Of Service</span>
                  </a>
                );
              }

              if (part === "Privacy_Policy") {
                return (
                  <a
                    style={{ textDecoration: "underline", color: "#474747" }}
                    href={this.state.privacyUrl}
                    target="_blank"
                  >
                    <span style={{ fontSize: 11 }}>Privacy Policy</span>
                  </a>
                );
              }
              return (
                <span className={'text-terms-of-service'}>{part}</span>
              );
            })}
          </div>
        </div>
        <span style={{color: 'gray', fontSize: 10}}>{this.showBranchVersion()}</span>
        <style>
        {`
          @keyframes phone-bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }
          @keyframes zoom-in-out {
            0% {
              font-size: 20px;
            }
            50% {
              font-size: 24px;
            }
            100% {
              font-size: 20px;
            }
          }
        `}
      </style>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    callDetails: state.callDetails,
    adminVars: state.adminVars,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setCallDetailsCountryId: (countryId) => { dispatch(setCallDetailsCountryId(countryId)) },
    setCallDetailsServiceSubject: (serviceSubject) => { dispatch(setCallDetailsServiceSubject(serviceSubject)) },
    setCallDetailsActive: (active) => { dispatch(setCallDetailsActive(active)) },
    setCallDetailsLongLat: (longLat) => { dispatch(setCallDetailsLongLat(longLat)) },
    setAdminVars: (adminVars) => { dispatch(setAdminVars(adminVars)) },
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(withTranslation("translation")(IframeContainer));
